export default __webpack_public_path__ + "static/media/slice-background-large.22249c10.jpg";